import React, { useState, useEffect, useRef } from "react";
import styles from './ProductImages.module.css';
import Image from 'next/image';
import { ProductType, ImageLink } from "../../../types/Product";
import Header from "../header/Header";
export const ProductImages: React.FC<ProductType & {
  onExpandClick: () => void;
  onMouseEnter?: () => void;
  expanded: boolean;
  productBasicInfoList: any[];
}> = ({
  id,
  index,
  title,
  picture,
  price,
  rating,
  brand,
  buyer,
  sub_category,
  amazon_link,
  reviewer_number,
  score,
  analysis_result,
  Image_Links,
  onExpandClick,
  onMouseEnter,
  expanded,
  pros,
  cons,
  productBasicInfoList
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [links, setLinks] = useState<string[]>([]); // Image links
  const [isMobile, setIsMobile] = useState(false); // State to detect mobile screen

  //This useState controls the current index of the image list
  const [currentIndex, setCurrentIndex] = useState(0);
  const pageSize = 3;
  const [maskStates, setMaskStates] = useState<boolean[]>([]);
  const [clickedImage, setClickedImage] = useState<string | null>(null);
  const imageGroupRef = useRef<HTMLDivElement>(null);

  // Fetch Image Links
  const image_result = productBasicInfoList[index]?.Image_Links;
  useEffect(() => {
    if (image_result) {
      const extractedLinks = image_result.map((image: ImageLink) => image.link);
      setLinks(extractedLinks);
      setClickedImage(extractedLinks[0]);

      // Initialize the mask state, set to display the first one by default
      const initialMaskStates = new Array(extractedLinks.length).fill(true);
      initialMaskStates[0] = false;
      setMaskStates(initialMaskStates);

      // console.log('images', extractedLinks);
    } else {
      // console.log(id, 'No images found');
    }
  }, [index, image_result]);

  // Detect if the screen size is mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);

    // Initial check
    handleResize();

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Handle scrolling through images, display 3 images in a roll
  const handleScrollerClick = (direction: string) => {
    if (imageGroupRef.current) {
      const scrollAmount = direction === 'next' ? 384 : -384;
      imageGroupRef.current.scrollBy({
        top: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  // Handle clicking on an image to update the displayed image on the right and mask state
  const handleImageClick = (idx: number) => {
    const updatedMaskStates = new Array(links.length).fill(true);
    updatedMaskStates[currentIndex + idx] = false;
    setMaskStates(updatedMaskStates);
    setClickedImage(links[currentIndex + idx]);
  };

  // Handle closing the clicked image view (close button)
  const handleCloseClick = () => {
    setClickedImage(links[0]); // Set default click as the first image
    setIsClicked(false);
    setIsHovered(false);
    setCurrentIndex(0); // reset currentIndex
    const updatedMaskStates = new Array(links.length).fill(true);
    updatedMaskStates[0] = false;
    setMaskStates(updatedMaskStates); // default remove the mask of the first image

    // Enable background scroll when closing
    document.body.style.overflow = 'auto';
  };
  useEffect(() => {
    if (isClicked) {
      document.body.style.overflow = 'hidden';
      if (isMobile) {
        setIsHovered(false);
      }
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isClicked, isMobile]);
  return <>
            <header>
                <link rel="preload" href={picture} as="image" />
            </header>

            <div id={styles.productImgContainer} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} style={{
      position: 'relative'
    }}>
                <Image src={picture} alt='product' id={styles.productImg} width={500} height={500} priority data-sentry-element="Image" data-sentry-source-file="ProductImages.tsx" />

                {isHovered && !isClicked && <div className={styles.productImgOverlay} onClick={() => setIsClicked(true)}>
                        <span>Click for More Images</span>
                    </div>}

                {isMobile &&
      // carousel dots for mobile version
      <div className={styles.carousel}>
                        <div className={`${styles.carouselDots} bg-[#424242]`} />
                        <div className={`${styles.carouselDots} bg-[#bebebe]`} />
                        <div className={`${styles.carouselDots} bg-[#bebebe]`} />
                        <div className={`${styles.carouselDots} bg-[#bebebe]`} />
                    </div>}

                {/* Full image gallery overlay when an image is clicked */}
                {isClicked && <div className={styles.fullOverlay}>
                        <div className={styles.ImagesContainer}>
                            {!isMobile && <div className={styles.ImagesGroupContainer}>
                                    <div className={styles.imageScroller} onClick={() => handleScrollerClick('prev')}>
                                        <Image className="w-6 h-6 relative origin-top-left" src="/assets/arrow-up.svg" alt="img" width={6} height={6}></Image>
                                    </div>
                                    {/* Image thumbnails */}
                                    <div className={styles.imageGroup} ref={imageGroupRef}>
                                        {Array.from({
                length: links.length
              }).map((_, idx) => <div key={idx} className={styles.imageDisplay} onClick={() => handleImageClick(idx)}>
                                                {links[currentIndex + idx] ? <div>
                                                        <img src={links[currentIndex + idx]} alt="img" className="h-28 relative" />
                                                        {maskStates[currentIndex + idx] && <div className="absolute inset-0 bg-black/20 hover:bg-white/30" />}
                                                    </div> : <div className="h-28 relative bg-neutral-100" />}
                                            </div>)}
                                    </div>
                                    <div className={styles.imageScroller} onClick={() => handleScrollerClick('next')}>
                                        <Image className="w-6 h-6 relative origin-top-left " src="/assets/arrow-down.svg" alt="img" width={6} height={6}></Image>
                                    </div>
                                </div>}

                            {isMobile &&
          // add a header for mobile version
          <div className="fixed inset-0">
                                    <Header disableSearch />
                                </div>}

                            {/* Display clicked image */}
                            <div className={styles.imageClickedContainer}>
                                <div className={styles.closeButton} onClick={handleCloseClick}>
                                    <div className={styles.closeButtonText}>CLOSE</div>
                                    <Image className="w-5 h-5 relative" src="/assets/cancel_button.svg" alt="img" width={5} height={5}></Image>
                                </div>
                                {clickedImage ? <div className={styles.imageClicked}>
                                        <img src={clickedImage} alt="Clicked Image" />
                                    </div> :
            // for NULL entries
            <img className="max-w-[572px] max-h-[332px] object-contain mx-auto" src="https://via.placeholder.com/572x322" alt="Placeholder" />}

                                {/* UI for mobile version */}
                                {isMobile && <div className={styles.imageGroup}>
                                        {links.map((link, idx) => <div key={idx} className={styles.imageDisplay}>
                                            <img src={link} alt="img" className="h-40 relative" />
                                            </div>)}
                                    </div>}
                            </div>
                        </div>
                    </div>}
            </div>
        </>;
};